<template>
    <div>
        <h1>{{ settingObj.name }} : Page de test</h1>
        <input type="hidden" id="txt_url" v-model="host">
        <input type="hidden" id="txt_key" v-model="apiKey">
        <input type="hidden" id="txt_setting" v-model="settingObj.id">
        <table>
            <tr>
                <td><label for="txt_titre">Titre&nbsp;:</label></td>
                <td><input type="text" id="txt_titre" name="txt_titre" size="100" value="Parlez vous le language des fleurs?"/></td>
            </tr>
            <tr>
                <td valign="top"><label for="txt_text">Texte&nbsp;:</label></td>
                <td><textarea name="txt_text" cols="100" rows="30" id="txt_text" spellcheck="false">Pour une communication élégante et raffinée

Au Moyen Âge, les dames portaient a leur corsage quelques fleurs, accompagnés de plantes aromatiques, pour pallier aux mauvaises odeurs. Elles étaient également utiliser pour transmettre un message, qu’on différentiait selon la fleur choisi.

Traditionnellemment, on prète à chaque fleurs l’expression d’un sentiment. Si la rose est bien connu pour être le symbole de l’amour et le chrisenteme celui de l’éternité, que dire du raudhodindron ? S’utilise t’il dans ce langage ? Oui, pour exprimer le danger. Et si l’on soufre d’un amour incomprit, on peut envisagé d’offrir des gencianes.

La couleur, elle aussi, joue un role important. Ainsi, le blanc symbolise la pureté, mais aussi l’élégance, le rafinement. La couleur rouge exprime l’ardeur, la fougue. Quant au violet, on s’en serre pour transmettre l’idée de la délicatesse, de la douceur. L’intensité de la couleur peut également être interprété : plus une couleur est pale, plus le sentiment est discret. Des fleurs roses claires incarne la douceur ou la bonne humeur, des fleurs jaunes foncées symbolisent la trahison et l’infidélité.

La manière dont les fleurs sont présenté est enfin à soigner. Le moindre petit détail peut avoir son importance, il en va de la clarté du message. Ainsi, mélanger ensemble des roses rouge et blanches revient à dire : « nous sommes inséparable ». Attacher un ruban vers la gauche signifit que le symbolisme des fleurs s’applique à celui qui les offres, vers la droite, à celui qui les reçoit.

L’églantine est la fleur des poetes.</textarea></td>
            </tr>
        </table>
        <p style="text-align: center;">
            <input type="button" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored" id="btn_analyze" value="Analyser">
        </p>
    </div>
</template>

<script>
    import { diagonalbackURL, defaultConfig } from "../constantes";
    import FctUtils from '@/components/FctUtils';
    import axios from 'axios';

    export default {
        name: "TestPL",
        mixins: [FctUtils],
        props:{
            settingProps: {type:String}, // arrive depuis un push -> String
        },
        data(){
            return {
                settingObj: {},
                host: 'ff',
                apiKey: ''
            }
        },
        created() {
            // Si pas de settings, on regarde s'il n'y en a pas un deja dans le store
            if (!FctUtils.methods.noEmpty(this.settingProps)) {
                this.settingObj = this.$store.getters.setting;
            }
            else {
                this.settingObj = JSON.parse(this.settingProps);
            }
        
            // Si Setting Ok, on affiche les soumissions correspondantes
            // si toujours pas de setting, on retourne vers la selection de la configuration
            if (!FctUtils.methods.noEmpty(this.settingObj)) {
                this.$router.push({name:"SelectDicoSetting", 
                    params: {
                        from: "TestPL"
                    }
                });
            }
            else {
                axios(diagonalbackURL + '/clients/'+ this.settingObj.clientId +'/hosts',  defaultConfig)
                .then(reponse => {
                    let aHostData = reponse.data;
                    for (var i = 0; i < aHostData.length; i++) {
                        for (var j = 0; j < aHostData[i].apiKeys.length; j++) {
                            if (aHostData[i].apiKeys[j].settingId == this.settingObj.id) {
                                // Correspondance trouvée
                                //
                                this.host = aHostData[i].name;
                                this.apiKey = aHostData[i].apiKeys[j].value;
                                break;
                            }
                        }

                        // Aucune clé d'api ne correspont
                        if (this.host == 'ff') {
                            for (var j = 0; j < aHostData[i].authorizedAddress.length; j++) {
                                if (aHostData[i].authorizedAddress[j].settingId == this.settingObj.id) {
                                    // Correspondance trouvée
                                    //
                                    this.host = aHostData[i].name;
                                    break;
                                }
                            }
                        }
                    }

                    console.log(this.host +' '+ this.apiKey);
                })
                .catch(error => this.errorHandler(error));
            }
        },
        //mounted will execute at pageload
        mounted:function(){
              this.onloading();
        },
        methods:{
            onloading:function(){
                var self = this;
                // Fields to analyze.
                //
                var eltToCorrect = [
                    {
                        src: document.getElementById('txt_titre'),
                        type: "txt",
                        label: "Titre"
                    },
                    {
                        src: document.getElementById('txt_text'),
                        type: "txt",
                        label: "Texte"
                    }
                ];
                
                
                // Click handler on button "Analyse"
                //
                document.getElementById('btn_analyze').onclick = function() {
                    // ProLexis Web Interface initialisation.
                    // First call load all needed ressources (CSS, ...).
                    //
                    if (self.apiKey != '') {
                        // Initialisation AVEC clé d'API
                        DiagPlWs.init({
                            // Proxy or ProLexis WebService URL
                            //
                            sUrlProxy: window.location.protocol +'//'+ document.getElementById('txt_url').value +'/prolexisws/v4/ProLexisService',
                            apiKey: document.getElementById('txt_key').value,
                            sCorePath: 'lib/diagonalWS'
                        });
                    }
                    else {
                        // Initialisation SANS clé d'API
                        DiagPlWs.init({
                            // Proxy or ProLexis WebService URL
                            //
                            sUrlProxy: window.location.protocol +'//'+ document.getElementById('txt_url').value +'/prolexisws/v4/ProLexisService',
                            sCorePath: 'lib/diagonalWS'
                        });
                    }

                    // ProLexis Web Interface analyze.
                    // Open the correction UI.
                    //
                    DiagPlWs.analyze(eltToCorrect);
                };
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
